<template>

  <div>
    <router-view/>
  </div>

</template>

<script>
  // @vuese
  // This wraps the Root components
  // @group Wrappers
  export default {
    name:'Admin',
    components: {
     },


  };
</script>

